import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

const app = initializeApp(firebaseConfig)
let messaging = null

const getMessagingClient = async () => {
  if (typeof window === 'undefined') return null
  if (!('serviceWorker' in navigator)) return null
  if (!window.isSecureContext) return null

  const supported = await isSupported()
  if (!supported) return null

  if (!messaging) {
    messaging = getMessaging(app)
  }

  return messaging
}

export const requestForToken = async () => {
  try {
    const messagingClient = await getMessagingClient()
    if (!messagingClient) return null

    if (!('Notification' in window)) return null
    if (Notification.permission !== 'granted') return null

    if (!import.meta.env.VITE_FIREBASE_VAPID_KEY) return null

    // Manually register service worker with config as query params
    const swUrl = `/firebase-messaging-sw.js?apiKey=${firebaseConfig.apiKey}&authDomain=${firebaseConfig.authDomain}&projectId=${firebaseConfig.projectId}&storageBucket=${firebaseConfig.storageBucket}&messagingSenderId=${firebaseConfig.messagingSenderId}&appId=${firebaseConfig.appId}`

    await navigator.serviceWorker.register(swUrl, {
      scope: '/',
    })
    const registration = await navigator.serviceWorker.ready
    if (!registration?.pushManager) return null

    const currentToken = await getToken(messagingClient, {
      vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration: registration,
    })
    if (currentToken) {
      return currentToken
    } else {
      console.log('No registration token available. Request permission to generate one.')
      return null
    }
  } catch (err) {
    console.log('An error occurred while retrieving token. ', err)
    return null
  }
}

export const onMessageListener = (callback) => {
  let unsubscribe = () => {}

  void getMessagingClient().then((messagingClient) => {
    if (!messagingClient) return
    unsubscribe = onMessage(messagingClient, (payload) => {
      callback(payload)
    })
  })

  return () => {
    unsubscribe()
  }
}

export { app, messaging }
